import React, { useEffect, useState } from 'react';
import { withRouter } from "react-router-dom";
import { store } from "react-notifications-component";

import ArrowIcon from "../../../assets/icons/icon-arrow-down-circle-gray.png";
import cancelaIcon from "../../../assets/icons/icon-trash-red.png";

import HeaderV2 from '../../../components/headerV2';

import * as S from './styles';
import {
    RowCard,
    Dispensed,
    ContainerImageCard,
    ContainerInputsAndButtons,
    ContainerInputsSelect,
    ContainerRelationOptions,
} from '../../../components/prescriptionsteps/step1/styles';
import SelectV2StepOne from '../../../components/select/select_v2_step_one';
import ButtonV2 from '../../../components/button/button_v2';
import api from '../../../services/api';
import Relation from '../../../components/prescriptionsteps/step1/relation';
import Interruptor from '../../../components/interruptor';
import { TaglineG } from '../../../styles/stylesTypography';

const ConfigurarProdutos = ({ ...props }) => {
    const userData = JSON.parse(localStorage.getItem("@userinfo") || "null");
    const isMaster = userData?.agro_permission_id === 4;

    const buildRelationInfo = () => ({
        epocaAplicacao: '',
        modalidadeAplicacao: '',
        dose: '',
        numeroAplicacoes: '',
        areaTratar: '',
        quantidadeAdquirir: '',
        volumeCalda: '',
        equipamento: '',
        dataEmissao: '',
    });

    const [relations, setRelations] = useState([0]);
    const [openRelation, setOpenRelation] = useState([false]);
    const [savedConfigIds, setSavedConfigIds] = useState([null]);
    const [culturasId, setCulturasId] = useState(['']);
    const [produtosId, setProdutosId] = useState(['']);
    const [pragasId, setPragasId] = useState(['']);
    const [relationsInfoArray, setRelationsInfoArray] = useState([buildRelationInfo()]);

    const [culturas, setCulturas] = useState([[]]);
    const [produtos, setProdutos] = useState([[]]);
    const [pragas, setPragas] = useState([[]]);

    const [loadingByIndex, setLoadingByIndex] = useState([false]);
    const [loadingRelationFetch, setLoadingRelationFetch] = useState([false]);
    const [loadingCompendio, setLoadingCompendio] = useState(false);
    const [loadingConfigs, setLoadingConfigs] = useState(false);
    const [loadingLista, setLoadingLista] = useState(false);
    const [savingIndex, setSavingIndex] = useState(null);
    const [isErroNotRelation, setIsErroNotRelation] = useState([false]);
    const [funcaoAtiva, setFuncaoAtiva] = useState(true);
    const [loadingToggleGlobal, setLoadingToggleGlobal] = useState(false);
    const [configAtivo, setConfigAtivo] = useState([true]);
    const [existDispensedProduct, setExistDispensedProduct] = useState(false);
    const [dispensedIndex, setDispensedIndex] = useState('');
    const [saveDate, setSaveDate] = useState('');

    const formatCulturas = (rawCulturas = []) => (
        rawCulturas.map((cultura) => ({
            value: cultura.id,
            label: cultura.nome_comum,
        }))
    );

    const formatProdutos = (rawProdutos = []) => (
        rawProdutos.map((produto) => ({
            value: produto.id,
            label: `${produto.nome_comercial} - ${produto.fabricante}`,
            dispensado: produto.receituario_dispensado,
        }))
    );

    const formatPragas = (rawPragas = []) => (
        rawPragas.map((praga) => ({
            value: praga.id,
            label: `${praga.nome_comum} - ${praga.nome_cientifico}`,
            nome_cientifico: praga.nome_cientifico,
        }))
    );

    const setErroByIndex = (index, value) => {
        setIsErroNotRelation((prev) => {
            const next = Array.isArray(prev) ? [...prev] : [];
            next[index] = value;
            return next;
        });
    };

    const setRowLoading = (index, value) => {
        setLoadingByIndex((prev) => {
            const next = Array.isArray(prev) ? [...prev] : [];
            next[index] = value;
            return next;
        });
    };

    const getCompendioOptionsByIds = async (produto, cultura, praga) => {
        const produtoParam = produto || '*';
        const culturaParam = cultura || '*';
        const pragaParam = praga || '*';
        const response = await api.get(`/compendio/${produtoParam}/${culturaParam}/${pragaParam}/SP`);
        const data = response?.data?.data || {};
        return {
            culturas: formatCulturas(data.culturas || []),
            produtos: formatProdutos(data.produtos || []),
            pragas: formatPragas(data.pragas || []),
        };
    };

    const searchCompendio = async (index, nextValues = {}) => {
        const produto = nextValues.produto ?? produtosId[index] ?? '*';
        const cultura = nextValues.cultura ?? culturasId[index] ?? '*';
        const praga = nextValues.praga ?? pragasId[index] ?? '*';
        const estado = 'SP';

        const produtoParam = produto || '*';
        const culturaParam = cultura || '*';
        const pragaParam = praga || '*';

        try {
            setRowLoading(index, true);
            setLoadingCompendio(true);

            const response = await api.get(`/compendio/${produtoParam}/${culturaParam}/${pragaParam}/${estado}`);
            const data = response?.data?.data;
            if (!data) return;

            const nextCulturas = Array.isArray(culturas) ? [...culturas] : [];
            const nextProdutos = Array.isArray(produtos) ? [...produtos] : [];
            const nextPragas = Array.isArray(pragas) ? [...pragas] : [];

            nextCulturas[index] = formatCulturas(data.culturas || []);
            nextProdutos[index] = formatProdutos(data.produtos || []);
            nextPragas[index] = formatPragas(data.pragas || []);

            setCulturas(nextCulturas);
            setProdutos(nextProdutos);
            setPragas(nextPragas);

            const hasOnlyOneProduct = nextProdutos[index]?.length === 1;
            if (hasOnlyOneProduct && produtoParam !== '*') {
                if (nextProdutos[index][0]?.dispensado === 1) {
                    setExistDispensedProduct(true);
                    setDispensedIndex(index);
                } else if (dispensedIndex === index) {
                    setExistDispensedProduct(false);
                    setDispensedIndex('');
                }
            } else if (dispensedIndex === index) {
                setExistDispensedProduct(false);
                setDispensedIndex('');
            }

            if (produtoParam !== '*' && culturaParam !== '*' && pragaParam !== '*') {
                await searchRelationId(produtoParam, culturaParam, pragaParam, index);
            }
        } catch (error) {
            // Mantem a tela utilizavel mesmo com erro na rota.
        } finally {
            setRowLoading(index, false);
            setLoadingCompendio(false);
        }
    };

    const searchRelationId = async (produto, cultura, praga, index) => {
        try {
            const response = await api.get(`/relacoes/${produto}/${cultura}/${praga}`);
            const data = response?.data?.data;
            if (!Array.isArray(data) || data.length === 0) return;

            setErroByIndex(index, false);

            const nextRelations = Array.isArray(relations) ? [...relations] : [];
            if (data.length === 1 && (!data[0]?.agro_relations_exceptions || data[0].agro_relations_exceptions.length === 0)) {
                nextRelations[index] = data[0].id;
            } else {
                nextRelations[index] = data.map((rel) => ({ relacao: rel }));
            }
            setRelations(nextRelations);

            if (!(existDispensedProduct && dispensedIndex === index)) {
                const nextOpen = Array(nextRelations.length).fill(false);
                nextOpen[index] = true;
                setOpenRelation(nextOpen);
            }
        } catch (error) {
            const message = error?.response?.data?.errors || error?.response?.data?.message || 'Erro ao buscar relação. Verifique os parâmetros selecionados.';
            showError(message);
            setErroByIndex(index, true);
        }
    };

    const saveRelationInfo = (relationInfo, index) => {
        setRelationsInfoArray((prev) => prev.map((item, i) => (i === index ? relationInfo : item)));
    };

    const changeRelationId = (id, index) => {
        setRelations((prev) => prev.map((item, i) => (i === index ? id : item)));
    };

    const showError = (message) => {
        store.addNotification({
            title: "Erro!",
            message,
            type: "danger",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 4000, onScreen: true },
        });
    };

    const showSuccess = (message) => {
        store.addNotification({
            title: "Sucesso!",
            message,
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
        });
    };

    const toNumberOrNull = (value) => {
        if (value === '' || value === null || value === undefined) return null;
        const parsed = Number(value);
        return Number.isNaN(parsed) ? null : parsed;
    };

    const toDecimalString = (value) => {
        if (value === '' || value === null || value === undefined) return '';
        const normalized = String(value).replace(',', '.');
        const parsed = Number(normalized);
        if (Number.isNaN(parsed)) return '';
        return parsed.toFixed(2);
    };

    const extractOptionValue = (value) => {
        if (value && typeof value === 'object') return value.value || '';
        return value || '';
    };

    const handleFuncaoAtivaChange = async (value) => {
        try {
            setLoadingToggleGlobal(true);
            // toggle ON (value=true) = habilitar tudo → ativo: 1
            // toggle OFF (value=false) = desabilitar tudo → ativo: 0
            await api.post('/relacoes/inativar-relacoes', { ativo: value ? 1 : 0 });
            setFuncaoAtiva(value);
            setConfigAtivo((prev) => prev.map(() => value));
        } catch (error) {
            showError('Não foi possível atualizar o status das configurações.');
        } finally {
            setLoadingToggleGlobal(false);
        }
    };

    const handleConfigAtivoChange = async (index, value) => {
        const configId = savedConfigIds[index];
        if (!configId) {
            setConfigAtivo((prev) => prev.map((item, i) => (i === index ? value : item)));
            return;
        }
        try {
            await api.post(`/relacoes/inativar/${configId}`, { ativo: value ? 1 : 0 });
            setConfigAtivo((prev) => prev.map((item, i) => (i === index ? value : item)));
        } catch (error) {
            showError('Não foi possível atualizar o status da configuração.');
        }
    };

    const fetchSavedConfigs = async () => {
        try {
            setLoadingLista(true);
            setLoadingConfigs(true);
            const response = await api.get('/relacoes/listar');
            const list = response?.data?.data || response?.data || [];
            if (!Array.isArray(list)) {
                await searchCompendio(0, { produto: '*', cultura: '*', praga: '*' });
                return;
            }

            const normalized = list
                .map((item) => ({
                    configId: item?.id || item?.config_id || item?.relacao_config_id || null,
                    relationId: item?.relation_id || item?.relacao_id || 0,
                    culturaId: item?.cultura_id || '',
                    produtoId: item?.product_id || item?.produto_id || '',
                    pragaId: item?.pest_id || item?.praga_id || '',
                    ativo: item?.ativo !== undefined ? Number(item.ativo) !== 0 : true,
                    info: {
                        ...buildRelationInfo(),
                        modalidadeAplicacao: item?.aplication_id
                            ? { value: Number(item.aplication_id), label: '' }
                            : '',
                        dose: item?.dosagem || '',
                        numeroAplicacoes: item?.num_aplicacao || '',
                        areaTratar: item?.area_tratar || '',
                        quantidadeAdquirir: item?.qtd_adquiri || item?.qtd_adquirir || '',
                        equipamento: item?.equip_aplicacao || '',
                    },
                }))
                .filter((item) => item.configId);

            if (normalized.length === 0) {
                setRelations([0]);
                setSavedConfigIds([null]);
                setCulturasId(['']);
                setProdutosId(['']);
                setPragasId(['']);
                setOpenRelation([false]);
                setRelationsInfoArray([buildRelationInfo()]);
                setCulturas([[]]);
                setProdutos([[]]);
                setPragas([[]]);
                setLoadingByIndex([false]);
                setConfigAtivo([true]);
                await searchCompendio(0, { produto: '*', cultura: '*', praga: '*' });
                return;
            }

            setRelations(normalized.map((item) => item.relationId));
            setSavedConfigIds(normalized.map((item) => item.configId));
            setCulturasId(normalized.map((item) => item.culturaId));
            setProdutosId(normalized.map((item) => item.produtoId));
            setPragasId(normalized.map((item) => item.pragaId));
            setRelationsInfoArray(normalized.map((item) => item.info));
            setOpenRelation(normalized.map(() => false));
            setLoadingByIndex(normalized.map(() => false));
            const ativos = normalized.map((item) => item.ativo);
            setConfigAtivo(ativos);
            // funcaoAtiva = true se TODOS estiverem ativos
            setFuncaoAtiva(ativos.length === 0 || ativos.every((v) => v));

            // Carrega as options da linha para que os Selects exibam os labels
            // correspondentes aos IDs já salvos (produto/cultura/praga).
            const optionsPerRow = await Promise.all(
                normalized.map(async (item) => {
                    try {
                        return await getCompendioOptionsByIds(item.produtoId, item.culturaId, item.pragaId);
                    } catch (error) {
                        return { culturas: [], produtos: [], pragas: [] };
                    }
                })
            );

            setCulturas(optionsPerRow.map((item) => item.culturas));
            setProdutos(optionsPerRow.map((item) => item.produtos));
            setPragas(optionsPerRow.map((item) => item.pragas));
        } catch (error) {
        } finally {
            setLoadingConfigs(false);
            setLoadingLista(false);
        }
    };

    const loadSavedConfigByIndex = async (index) => {
        const configId = savedConfigIds[index];
        if (!configId) return;
        try {
            setLoadingConfigs(true);
            const response = await api.get(`/relacoes/listar/${configId}`);
            const payload = response?.data?.data || response?.data;
            const config = Array.isArray(payload) ? payload[0] : payload;
            if (!config) return;

            const relationId = config.relation_id || config.relacao_id || 0;
            const culturaId = config.cultura_id || '';
            const productId = config.product_id || '';
            const pestId = config.pest_id || '';

            setCulturasId((prev) => prev.map((value, i) => (i === index ? culturaId : value)));
            setProdutosId((prev) => prev.map((value, i) => (i === index ? productId : value)));
            setPragasId((prev) => prev.map((value, i) => (i === index ? pestId : value)));
            setRelations((prev) => prev.map((value, i) => (i === index ? relationId : value)));
            setOpenRelation((prev) => prev.map((value, i) => (i === index ? true : value)));

            setRelationsInfoArray((prev) => prev.map((item, i) => (
                i === index
                    ? {
                        ...item,
                        modalidadeAplicacao: config.aplication_id
                            ? { value: Number(config.aplication_id), label: '' }
                            : '',
                        dose: config.dosagem || '',
                        numeroAplicacoes: config.num_aplicacao || '',
                        areaTratar: config.area_tratar || '',
                        quantidadeAdquirir: config.qtd_adquiri || config.qtd_adquirir || '',
                        equipamento: config.equip_aplicacao || '',
                    }
                    : item
            )));

            await searchCompendio(index, { produto: productId, cultura: culturaId, praga: pestId });
        } catch (error) {
            showError('Nao foi possivel carregar os detalhes da configuracao.');
        } finally {
            setLoadingConfigs(false);
        }
    };

    const saveOrUpdateRelation = async (index) => {
        const relationValue = relations[index];
        const relationId = typeof relationValue === 'number'
            ? relationValue
            : (relationsInfoArray[index]?.relationId || 0);
        const info = relationsInfoArray[index] || {};

        if (!relationId || !culturasId[index] || !produtosId[index] || !pragasId[index]) {
            showError('Selecione Cultura, Produto e Praga e aguarde a relacao ser carregada.');
            return;
        }

        const payload = {
            relation_id: relationId,
            cultura_id: toNumberOrNull(culturasId[index]),
            pest_id: toNumberOrNull(pragasId[index]),
            product_id: toNumberOrNull(produtosId[index]),
            aplication_id: toNumberOrNull(extractOptionValue(info.modalidadeAplicacao)),
            dosagem: toNumberOrNull(info.dose),
            num_aplicacao: toNumberOrNull(info.numeroAplicacoes),
            area_tratar: toDecimalString(info.areaTratar),
            qtd_adquiri: toDecimalString(info.quantidadeAdquirir),
            equip_aplicacao: info.equipamento || '',
            ativo: configAtivo[index] ? 1 : 0,
        };

        try {
            setSavingIndex(index);
            const configId = savedConfigIds[index];
            if (configId) {
                await api.put(`/relacoes/editar/${configId}`, payload);
                showSuccess('Configuracao atualizada com sucesso.');
            } else {
                const response = await api.post('/relacoes/salvar', payload);
                const createdId = response?.data?.data?.id || response?.data?.id || null;
                if (createdId) {
                    setSavedConfigIds((prev) => prev.map((value, i) => (i === index ? createdId : value)));
                }
                showSuccess('Configuracao salva com sucesso.');
            }
            await fetchSavedConfigs();
        } catch (error) {
            showError('Nao foi possivel salvar a configuracao.');
        } finally {
            setSavingIndex(null);
        }
    };

    const openBoxRelation = async (index) => {
        const isOpening = !openRelation[index];
        if (isOpening) {
            if (!produtosId[index] || !culturasId[index] || !pragasId[index]) {
                showError('Relação incompleta. Selecione Produto, Cultura e Praga para continuar a configuração.');
                return;
            }
            await searchRelationId(produtosId[index], culturasId[index], pragasId[index], index);
        } else {
            setOpenRelation((prev) => prev.map((value, i) => (i === index ? false : value)));
        }
    };

    const closeAndResetRelation = (index) => {
        setOpenRelation((prev) => prev.map((value, i) => (i === index ? false : value)));
        setRelations((prev) => prev.map((value, i) => (i === index ? 0 : value)));
    };

    const changeProductOnRelation = (product, index) => {
        const value = product?.value || '';
        console.log("Produto selecionado:", product);
        setProdutosId((prev) => prev.map((item, i) => (i === index ? value : item)));
        if (!value) {
            closeAndResetRelation(index);
        }
        searchCompendio(index, { produto: value });
        if (isErroNotRelation[index]) setErroByIndex(index, false);
    };

    const changeCultureOnRelation = (culture, index) => {
        const value = culture?.value || '';
        setCulturasId((prev) => prev.map((item, i) => (i === index ? value : item)));
        if (!value) {
            closeAndResetRelation(index);
        }
        searchCompendio(index, { cultura: value });
        if (isErroNotRelation[index]) setErroByIndex(index, false);
    };

    const changePestOnRelation = (pest, index) => {
        const value = pest?.value || '';
        setPragasId((prev) => prev.map((item, i) => (i === index ? value : item)));
        if (!value) {
            closeAndResetRelation(index);
        }
        searchCompendio(index, { praga: value });
        if (isErroNotRelation[index]) setErroByIndex(index, false);
    };

    const updateRelationInfo = (index, field, value) => {
        setRelationsInfoArray((prev) => prev.map((item, i) => (
            i === index ? { ...item, [field]: value } : item
        )));
    };

    const deleteRelation = async (index) => {
        const configId = savedConfigIds[index];
        if (configId) {
            try {
                setLoadingConfigs(true);
                await api.delete(`/relacoes/deletar/${configId}`);
                showSuccess('Configuracao removida com sucesso.');
                await fetchSavedConfigs();
            } catch (error) {
                showError('Nao foi possivel remover a configuracao.');
            } finally {
                setLoadingConfigs(false);
            }
            return;
        }

        if (relations.length === 1) {
            setSavedConfigIds([null]);
            setCulturasId(['']);
            setProdutosId(['']);
            setPragasId(['']);
            setOpenRelation([false]);
            setRelationsInfoArray([buildRelationInfo()]);
            setLoadingByIndex([false]);
            setIsErroNotRelation([false]);
            setConfigAtivo([true]);
            return;
        }

        setRelations((prev) => prev.filter((_, i) => i !== index));
        setOpenRelation((prev) => prev.filter((_, i) => i !== index));
        setSavedConfigIds((prev) => prev.filter((_, i) => i !== index));
        setCulturasId((prev) => prev.filter((_, i) => i !== index));
        setProdutosId((prev) => prev.filter((_, i) => i !== index));
        setPragasId((prev) => prev.filter((_, i) => i !== index));
        setRelationsInfoArray((prev) => prev.filter((_, i) => i !== index));
        setLoadingByIndex((prev) => prev.filter((_, i) => i !== index));
        setCulturas((prev) => prev.filter((_, i) => i !== index));
        setProdutos((prev) => prev.filter((_, i) => i !== index));
        setPragas((prev) => prev.filter((_, i) => i !== index));
        setIsErroNotRelation((prev) => prev.filter((_, i) => i !== index));
        setConfigAtivo((prev) => prev.filter((_, i) => i !== index));

        if (dispensedIndex === index) {
            setExistDispensedProduct(false);
            setDispensedIndex('');
        }
    };

    const addNewRelation = () => {
        const newIndex = relations.length;
        setRelations((prev) => [...prev, 0]);
        setOpenRelation((prev) => [...prev, false]);
        setSavedConfigIds((prev) => [...prev, null]);
        setCulturasId((prev) => [...prev, '']);
        setProdutosId((prev) => [...prev, '']);
        setPragasId((prev) => [...prev, '']);
        setRelationsInfoArray((prev) => [...prev, buildRelationInfo()]);
        setLoadingByIndex((prev) => [...prev, false]);
        setIsErroNotRelation((prev) => [...prev, false]);
        setConfigAtivo((prev) => [...prev, true]);
        setCulturas((prev) => [...prev, []]);
        setProdutos((prev) => [...prev, []]);
        setPragas((prev) => [...prev, []]);
        searchCompendio(newIndex, { produto: '*', cultura: '*', praga: '*' });
    };

    useEffect(() => {
        fetchSavedConfigs();
    }, []);


    return (
        <S.Container>
            <HeaderV2 title="Configurar Produtos" />

            {isMaster && (
                <S.ContainerToggleGlobal>
                    <TaglineG>Habilitar todas as configurações de produtos</TaglineG>
                    <Interruptor value={funcaoAtiva} onChange={handleFuncaoAtivaChange} />
                </S.ContainerToggleGlobal>
            )}

            <S.Wrapper>
                {loadingLista ? <S.Loading /> : (
                    <>

                {relations.map((relationId, index) => (
                    <RowCard
                        isBorder={true}
                        key={`relation-${index}`}
                        openBox={openRelation[index]}
                        erro={isErroNotRelation[index]}
                        inativo={!configAtivo[index]}
                        maxHeight="auto"
                        height='auto'
                    >
                        <ContainerInputsAndButtons
                            openRelation={openRelation[index]}
                            index={index}
                        >
                            <ContainerImageCard>
                                <img className="cancel" alt='cancelar' onClick={() => deleteRelation(index)} src={cancelaIcon} />
                            </ContainerImageCard>

                            <ContainerInputsSelect>
                                <div className="selectValue">
                                    <SelectV2StepOne
                                        name="agro_product_id"
                                        className="select"
                                        label="Produto"
                                        id={`produto-${index}`}
                                        value={produtosId[index] || ''}
                                        disabled={!!loadingByIndex[index] || !configAtivo[index]}
                                        isClearable={true}
                                        onChange={produto => changeProductOnRelation(produto, index)}
                                        options={produtos[index] || [""]}
                                        isCompact={true}
                                        isSearch={true}
                                        width='270px'
                                        selectUniqueOption={false}
                                        isArrow={true}
                                        loading={!!loadingByIndex[index]}
                                        erro={isErroNotRelation[index]}
                                        solicitar={false}
                                        marginBottom="0px"
                                    />
                                </div>

                                <div className="selectValue">
                                    <SelectV2StepOne
                                        name="agro_culture_id"
                                        className="select"
                                        label="Cultura"
                                        id={`cultura-${index}`}
                                        value={culturasId[index] || ''}
                                        disabled={!!loadingByIndex[index] || !configAtivo[index]}
                                        isClearable={true}
                                        onChange={cultura => changeCultureOnRelation(cultura, index)}
                                        options={culturas[index] || [""]}
                                        isCompact={true}
                                        isSearch={true}
                                        width='270px'
                                        selectUniqueOption={false}
                                        isArrow={true}
                                        loading={!!loadingByIndex[index]}
                                        erro={isErroNotRelation[index]}
                                        solicitar={true}
                                        marginBottom="0px"
                                    />
                                </div>

                                <div className="selectValue">
                                    <SelectV2StepOne
                                        name="agro_pest_id"
                                        className="select"
                                        label="Praga/Alvo"
                                        id={`praga-${index}`}
                                        value={pragasId[index] || ''}
                                        disabled={!!loadingByIndex[index] || !configAtivo[index]}
                                        isClearable={true}
                                        onChange={praga => changePestOnRelation(praga, index)}
                                        options={pragas[index] || [""]}
                                        isCompact={true}
                                        isSearch={true}
                                        width='270px'
                                        selectUniqueOption={false}
                                        loading={!!loadingByIndex[index]}
                                        erro={isErroNotRelation[index]}
                                        searchPhoto={true}
                                        highlightScientificName
                                        marginBottom="0px"
                                    />
                                </div>
                            </ContainerInputsSelect>

                            {isMaster && (
                                <S.ContainerToggleRow>
                                    <TaglineG small>{configAtivo[index] ? 'Ativo' : 'Inativo'}</TaglineG>
                                    <Interruptor
                                        value={configAtivo[index] ?? true}
                                        onChange={(value) => handleConfigAtivoChange(index, value)}
                                    />
                                </S.ContainerToggleRow>
                            )}

                            <ContainerImageCard openBox={openRelation[index]}>
                                <img className="arrow" src={ArrowIcon} alt='arrow' onClick={() => openBoxRelation(index)} />
                            </ContainerImageCard>
                        </ContainerInputsAndButtons>

                        {existDispensedProduct && dispensedIndex === index ? (
                            <Dispensed> Produto dispensado de receituario </Dispensed>
                        ) : (
                            <>
                                {openRelation[index] ? (
                                    <S.ContainerRelationOptions height="auto">
                                        {(loadingByIndex[index] || loadingRelationFetch[index]) ? (
                                            <S.ContainerLoading>
                                                <S.Loading />
                                            </S.ContainerLoading>
                                        ) : null}
                                        <div style={{ display: (loadingByIndex[index] || loadingRelationFetch[index]) ? 'none' : undefined }}>
                                            <Relation
                                                index={index}
                                                date={saveDate}
                                                relation={relations[index]}
                                                relationInfo={relationsInfoArray[index]}
                                                updateRelationInfo={(relationInfo) => saveRelationInfo(relationInfo, index)}
                                                updateRelationId={(id) => changeRelationId(id, index)}
                                                isCompendio={false}
                                                compendioParams={''}
                                                estado={{ value: 'SP', label: 'SP' }}
                                                compendioLoading={loadingCompendio}
                                                recipeDraft={props.recipeDraft}
                                                hideEpocaAplicacao={true}
                                                hideDateEmission={true}
                                                hideVolumeCalda={true}
                                                hideAreaTratar={true}
                                                hideQuantidadeAdquirir={true}
                                                onLoadingChange={(loading) => setLoadingRelationFetch((prev) => {
                                                    const next = [...prev];
                                                    next[index] = loading;
                                                    return next;
                                                })}
                                            />

                                            {typeof relations[index] === 'number' && relations[index] !== 0 && (
                                                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 12 }}>
                                                    <ButtonV2
                                                        width='120px'
                                                        height='48px'
                                                        onClick={() => saveOrUpdateRelation(index)}
                                                        disabled={savingIndex === index}
                                                        value={savedConfigIds[index] ? 'Atualizar' : 'Salvar'}
                                                        loading={savingIndex === index || loadingCompendio}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </S.ContainerRelationOptions>
                                ) : null}
                            </>
                        )}
                    </RowCard>
                ))}

                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 12 }}>
                    <ButtonV2
                        width='280px'
                        height='48px'
                        value='Adicionar nova configuração'
                        onClick={addNewRelation}
                        imagePlus={true}
                    />
                </div>
                    </>
                )}
            </S.Wrapper>
        </S.Container>
    );
};

export default withRouter(ConfigurarProdutos);
